<fieldset class="option-group">
  <legend>{{ filterBase.label }}</legend>
  @if (loadingData) { <div class="group-status">טוען אפשרויות…</div> }
  <div class="option-grid">
    @for (item of items; track item.id) {
      <label class="option-chip" [class.selected]="isSelected(item)">
        <input type="checkbox" [checked]="isSelected(item)" (change)="selectCheckBox(item)">
        <span class="chip-check"><mat-icon>check</mat-icon></span>
        <span>{{ item.label }}</span>
      </label>
    }
  </div>
</fieldset>
